import moment from 'moment'

export const getComparableDaysOnMarket = (property, now = moment()) => {
  if (!property?.created) return null

  const createdAt = moment(property.created)
  if (!createdAt.isValid()) return null

  if (!property.inactive) {
    return Math.max(0, moment(now).diff(createdAt, 'days'))
  }

  if (Number.isFinite(property.daysOnMarket)) {
    return Math.max(0, property.daysOnMarket)
  }

  const inactiveDate = property.lastUpdate || property.updated || property.updatedAt
  if (!inactiveDate) return null

  const inactiveAt = moment(inactiveDate)
  if (!inactiveAt.isValid()) return null

  return Math.max(0, inactiveAt.diff(createdAt, 'days'))
}

export const formatComparableDaysOnMarket = (days) => {
  if (!Number.isFinite(days)) return 'doba neznámá'
  if (days === 1) return '1 den na trhu'

  const lastTwoDigits = days % 100
  const lastDigit = days % 10
  if (lastTwoDigits < 12 || lastTwoDigits > 14) {
    if (lastDigit >= 2 && lastDigit <= 4) return `${days} dny na trhu`
  }

  return `${days} dní na trhu`
}

export const getComparableMarketStatus = (property, now) => {
  const inactive = Boolean(property?.inactive)
  return {
    inactive,
    label: inactive ? 'Neaktivní' : 'Aktivní',
    badgeClassName: inactive ? 'bg-red-100 text-red-800' : 'bg-green-100 text-green-800',
    daysOnMarket: getComparableDaysOnMarket(property, now),
  }
}
